// extracted by mini-css-extract-plugin
module.exports = {"formWidth":"Language_formWidth__36nRV","formContainer":"Language_formContainer__-Sate","label":"Language_label__2ClRS"};